import app from './app';
import experimentation from './experimentation';
import user from './user';
import metadata from './metadata';
import myapps from './myapps';
import appcenter from './appcenter';
import marketplaces from './marketplaces';
import productcompletion from './productcompletion';

export default {
  app,
  experimentation,
  user,
  metadata,
  myapps,
  appcenter,
  marketplaces,
  productcompletion
};
